import axios from 'axios';
import qs from 'qs';
import { CONSTANTS } from '../constants';
import {
  queueExportRequest,
  queueExportSuccess,
  queueExportError,
} from '../../../retailer/redux/actions/exports';

export type profileT = {
  userId: string;
};

export type actionT = {
  type: string;
  data?: profileT | any;
  error?: any;
};

export type dispatchT = (action: actionT) => void;
export type exceptionT = any;

export const requestFetchProfileDetails = () => ({
  type: CONSTANTS.FETCH_PROFILE_DETAILS_REQUEST,
});

export const receiveFetchProfileDetailsSuccess = (data: profileT) => ({
  type: CONSTANTS.FETCH_PROFILE_DETAILS_SUCCESS,
  data,
});

export const receiveFetchProfileDetailsFailure = (ex: exceptionT) => ({
  type: CONSTANTS.FETCH_PROFILE_DETAILS_FAILURE,
  error: ex,
});

export function fetchProfileDetailsAsync() {
  return (dispatch: dispatchT) => {
    dispatch(requestFetchProfileDetails());
    return axios
      .get('/v1/profiles', {
        method: 'GET',
        responseType: 'json',
      })
      .then(res => {
        dispatch(receiveFetchProfileDetailsSuccess(res.data));
        return res.data;
      })
      .catch(() => {});
  };
}

export const handleExportPdf = (paymentRequestId, token) => dispatch => {
  dispatch(queueExportRequest());
  dispatch({
    type: CONSTANTS.NOTIFY_EXPORT_SUCCESS,
    notificationPayload: 'Your invoice download will begin shortly.',
    notificationType: 'success',
    notificationDelay: 3000,
  });
  const qst = qs.stringify({ token });
  const url = `/v1/payment-requests/${paymentRequestId}/invoice-export?${qst}`;

  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    link.dispatchEvent(new MouseEvent('click'));
    dispatch(queueExportSuccess());
    return Promise.resolve({});
  } catch (rej) {
    dispatch(queueExportError());
    dispatch({
      type: CONSTANTS.NOTIFY_EXPORT_ERROR,
      notificationPayload: `Error submitting export request.
        Please contact support@ordermentum.com`,
      notificationType: 'error',
      notificationDelay: 3000,
    });
    return Promise.reject(rej);
  }
};
